module.exports = __webpack_public_path__ + "fonts/NespressoLucas-SemiBd.eot?v=c5f70e866754fdb9f9d555dfb83c2752";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-SemiBd.eot?
// module id = 673
// module chunks = 0